export default __webpack_public_path__ + "static/media/compounding-graph.1172e498.svg";